import { Input, InputGroup } from '@sb1/ffe-form-react';
import styles from './input-with-copy.module.less';
import { Chip } from '@sb1/ffe-chips-react';
import { Icon } from '@sb1/ffe-icons-react';
import { webShare } from '../../project/share/share-utils';
import { showErrorModal } from '../../global-message/global-message-actions';
import copyIcon from '@sb1/ffe-icons/icons/open/300/md/content_copy.svg';
import copy from 'clipboard-copy';
import { useState } from 'react';
import checkIcon from '@sb1/ffe-icons/icons/open/300/sm/check.svg';
import { useDispatch } from 'react-redux';

export const InputWithCopyButton = ({ label, trackEventFunction, prettyUrlToShare, isNative }) => {
    const [copied, setCopied] = useState(false);
    const dispatch = useDispatch();

    const nativeClick = async () => {
        await webShare({ urlToShare: prettyUrlToShare }).catch((err) => {
            if (!err.toString().includes('AbortError')) {
                dispatch(showErrorModal('Klarte ikke å dele.'));
            }
        });
    };

    const onCopyClick = () => {
        copy(prettyUrlToShare);
        setCopied(true);

        setTimeout(() => {
            setCopied(false);
        }, 2000);
    };

    return (
        <InputGroup label={label} className={styles.copyButtonGroup} extraMargin={false}>
            <div className={styles.inputWrapper}>
                <Input
                    className={styles.truncateInput}
                    value={prettyUrlToShare.replace('https://', '').replace('www.', '')}
                    readOnly
                />
                <Chip
                    leftIcon={<Icon fileUrl={copied ? checkIcon : copyIcon} />}
                    className={styles.copyButton}
                    onClick={() => {
                        trackEventFunction && trackEventFunction();
                        isNative ? nativeClick() : onCopyClick();
                    }}
                >
                    {copied ? 'Kopiert' : 'Kopiér'}
                </Chip>
            </div>
        </InputGroup>
    );
};
